import { getDepartments } from "../api/generated/wrappers/backdata";
import { createQueryKeys } from "./create-query-keys";
const departmentQueryKeys = createQueryKeys("department", {
    all: () => ({
        queryKey: ["all"],
        queryFn: getDepartments,
    }),
});
export default departmentQueryKeys;
